import {FAILURE, PENDING, SUCCESS} from '../../constants'

export const UT_FAILURE = `GET_USER_TEMPLATE_${FAILURE}`
export const UT_PENDING = `GET_USER_TEMPLATE_${PENDING}`
export const UT_SUCCESS = `GET_USER_TEMPLATE_${SUCCESS}`

export const UST_FAILURE = `GET_USER_SEARCH_TEMPLATE_${FAILURE}`
export const UST_PENDING = `GET_USER_SEARCH_TEMPLATE_${PENDING}`
export const UST_SUCCESS = `GET_USER_SEARCH_TEMPLATE_${SUCCESS}`
